import React, { useState } from 'react';

import { Paper } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSelectedFeedbackViewFromParam } from 'screens/Levelup/hooks/useSelectedFeedbackViewFromParam';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import styled, { css } from 'styled-components';
import { StyledDrawer } from 'styles/admin';
import { GutterCSS, StyledButton, Divider1, NewStyledIconButton } from 'styles/common';
import { checkFeedbackModuleEnabled } from 'utils/helpers/moduleAccess';

import { FEEDBACK_FORM_TYPE } from 'constants/ProjectConstants';
import { pushFeedbackParams } from 'constants/helper';
import { StyledIcon } from 'constants/icons';

import NotEnabled from '../common/NotEnabled';
import FeedbackView from './FeedbackView';
import MsRequestFeedback from './MsRequestFeedback';
import MsShareFeedback from './MsShareFeedback';

const makeSenderAndUserEmployeeAsOption = (employee) => {
  if (employee)
    return {
      ...employee,
      label: employee.displayName,
      value: employee.id,
    };
  return null;
};

const MsTeamsShareRequestedFeedback = () => {
  const [isSelectedMode, setIsSelectedMode] = useState(false);

  const history = useHistory();

  const employee = useSelector(selectLoggedInEmployeeData, shallowEqual);
  const { selectedFeedbackView } = useSelectedFeedbackViewFromParam();

  const handleRequestNewFeedbackClick = () => {
    pushFeedbackParams({
      history,
      formType: FEEDBACK_FORM_TYPE.REQUESTED,
      newForm: true,
      empId: employee.id ?? null,
      source: 'Ms Teams',
      selectedFeedbackView,
    });
  };

  const handleShareNewFeedbackClick = (isSharePublicPraise = false) => {
    pushFeedbackParams({
      history,
      formType: FEEDBACK_FORM_TYPE.PROVIDED,
      newForm: true,
      empId: null,
      source: 'Ms Teams',
      isSharePublicPraise,
      selectedFeedbackView,
    });
  };

  const onFeedbackModeChange = (value) => {
    pushFeedbackParams({
      history,
      formType: value === 'share' ? FEEDBACK_FORM_TYPE.PROVIDED : FEEDBACK_FORM_TYPE.REQUESTED,
      newForm: true,
      empId: value === 'share' ? null : employee.id,
      source: 'Ms Teams',
      selectedFeedbackView,
    });
  };

  if (!checkFeedbackModuleEnabled()) {
    return <NotEnabled />;
  }

  const handleListFeedbackClick = () => {
    const data = {
      history,
      formType: FEEDBACK_FORM_TYPE.LIST_FEEDBACKS,
      typeMapped: true,
      defaultTab: 0,
    };
    pushFeedbackParams(data);
  };

  return (
    <StyledWrapper>
      <FeedbackDrawer onClose={() => onFeedbackModeChange(false)} isSelectedMode={isSelectedMode} employee={employee} />
      <StyledPaperContainer>
        <FeedbackView
          // handleClose={handleClose}
          handleOpenShareForm={(isSharePublicPraise) => handleShareNewFeedbackClick(isSharePublicPraise)}
          handleOpenRequestForm={() => handleRequestNewFeedbackClick()}
          defaultTab={0}
        />
        {/* <SectionContainer>
          <div>
            <NotchedButton
              variant="outlined"
              selected={isSelectedMode === 'share'}
              customColor={isSelectedMode === 'share' ? 'primary' : 'white'}
              fontColor={isSelectedMode === 'share' ? 'white' : 'primary'}
              onClick={e => onFeedbackModeChange('share')}
              rightGutter={2}
            >
              <StyledTypography variant="body1">Share</StyledTypography>
            </NotchedButton>
            <NotchedButton
              variant="outlined"
              selected={isSelectedMode === 'request'}
              customColor={isSelectedMode === 'request' ? 'primary' : 'white'}
              fontColor={isSelectedMode === 'request' ? 'white' : 'primary'}
              onClick={e => onFeedbackModeChange('request')}
            >
              <StyledTypography variant="body1">Request</StyledTypography>
            </NotchedButton>
          </div>
          <div>
            <Button blueOutline onClick={handleListFeedbackClick}>
              Feedback List
            </Button>
          </div>
        </SectionContainer>
        {isSelectedMode === 'share' ? (
          <MsShareFeedback loggedInEmployee={makeSenderAndUserEmployeeAsOption(employee)} />
        ) : (
          <MsRequestFeedback loggedInEmployee={makeSenderAndUserEmployeeAsOption(employee)} />
        )} */}
      </StyledPaperContainer>
    </StyledWrapper>
  );
};
export default MsTeamsShareRequestedFeedback;

const StyledPaperContainer = styled(Paper)`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  width: 760px;
  margin-top: 25px;
`;
const SectionContainer = styled.div`
  margin: 0.5rem 0 2rem 0;
  display: flex;
  justify-content: space-between;
  ${GutterCSS}
`;
const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
`;
const NotchedButton = styled(StyledButton)`
  width: 15ch;

  border-color: ${(props) => props.theme.palette.primary.main};

  ${(props) =>
    props.selected &&
    css`
      &:after {
        content: ' ';
        width: 0px;
        height: 10px;
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-top: 7px solid #0088e6;
        display: inline-block;
        position: absolute;
        left: 50%;
        bottom: -10px;
        transform: translateX(-50%);
      }
    `};
`;

function FeedbackDrawer({ onClose, isSelectedMode, employee }) {
  return (
    <StyledDrawer anchor="right" open={isSelectedMode} ModalProps={{ onBackdropClick: onClose }}>
      <HeaderContainer>
        <div>{isSelectedMode === 'share' ? 'Share' : 'Request'} Feedback</div>
        <NewStyledIconButton onClick={onClose} padding="large">
          <StyledIcon color="textSecondary" size="header">
            <CloseRoundedIcon />
          </StyledIcon>
        </NewStyledIconButton>
      </HeaderContainer>
      <Divider1 topGutter={1.5} bottomGutter={1.5} />
      {isSelectedMode === 'share' ? (
        <MsShareFeedback loggedInEmployee={makeSenderAndUserEmployeeAsOption(employee)} onCancel={onClose} />
      ) : (
        <MsRequestFeedback loggedInEmployee={makeSenderAndUserEmployeeAsOption(employee)} onCancel={onClose} />
      )}
    </StyledDrawer>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0;
  padding: 5px 0;
`;
